import api from './api'

interface RequestParams {
  status?: string
  search?: string
  contractId?: string | null
  tagId?: string
  page: number
  rowsPerPage: number
  columnOrder: string[]
  organizationId: string
}

export interface BaseResponse<T> {
  statusCode: number
  data: T
}

const loadList = (route: string, params: RequestParams) => api.post(route, params)

const loadCount = (route: string, search: string) => api.post(route, { search })

const loadItem = (route: string, id: string): any => api.get(`${route}/${id}`)

const loadSingle = async <T>(route: string): Promise<BaseResponse<T>> => {
  const response = await api.get<T>(route)

  return {
    statusCode: response.status,
    data: response.data,
  }
}

const load = (route: string, params?: any) => api.post(route, params)

export { load, loadCount, loadItem, loadList, loadSingle }
